import React, { useState } from "react";
import "./form3.css";
import { useNavigate } from 'react-router-dom';

const Form3 = ({formData,setFormData,setStep}) => {
  

  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validate = () => {
    const newErrors = {};
    Object.entries(formData).forEach(([key, value]) => {
      if (!value.trim()) { 
        newErrors[key] = "required";
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 
  const HandleNext = (e) => { 
    e.preventDefault();
    if (validate()) {
      navigate(setStep(4));
    }
  };

  const handleBack = () => {
      setStep(2)
  };

  return (
    <>
    <div className="form3-background">
      <div className="form3-section">
        <h2 className="form3-title">Family Details(3/7)</h2>
        <form>
          <div className="form3-grid">
            <div className="form3-group">
              <label>Father Name<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherName" placeholder="Enter Your Father Name" value={formData.fatherName} onChange={handleChange} />
              {errors.fatherName && <span className="error-text">{errors.fatherName}</span>}
            </div>
            <div className="form3-group">
              <label>Mother Name<span className='error fs-star'>*</span></label>
              <input type="text" name="motherName" placeholder="Enter Your Mother Name" value={formData.motherName} onChange={handleChange} />
              {errors.motherName && <span className="error-text">{errors.motherName}</span>}
            </div>
            <div className="form3-group">
              <label>Father Job Description<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherJob" placeholder="Enter Your Father's Job Description" value={formData.fatherJob} onChange={handleChange} />
              {errors.fatherJob && <span className="error-text">{errors.fatherJob}</span>}
            </div>
            <div className="form3-group">
              <label>Mother Job Description<span className='error fs-star'>*</span></label>
              <input type="text" name="motherJob" placeholder="Enter Your Mother's Job Description" alue={formData.motherJob} onChange={handleChange} />
              {errors.motherJob && <span className="error-text">{errors.motherJob}</span>}
            </div>
            <div className="form3-group">
              <label>Father Native<span className='error fs-star'>*</span></label>
              <input type="text" name="fatherNative" placeholder="Enter Your Father's Native" value={formData.fatherNative} onChange={handleChange} />
              {errors.fatherNative && <span className="error-text">{errors.fatherNative}</span>}
            </div>
            <div className="form3-group">
              <label>Mother Native<span className='error fs-star'>*</span></label>
              <input type="text" name="motherNative" placeholder="Enter Your Mother's Native" value={formData.motherNative} onChange={handleChange} />
              {errors.motherNative && <span className="error-text">{errors.motherNative}</span>}
            </div>
            <div className="form3-group">
              <label>Siblings<span className='error fs-star'>*</span></label>
              <input type="text" name="siblings" placeholder="Enter number of siblings"  value={formData.siblings} onChange={handleChange} />
              {errors.siblings && <span className="error-text">{errors.siblings}</span>}
            </div>
            <div className="form3-group">
              <label>Property Details<span className='error fs-star'>*</span></label>
              <input type="text" name="property" placeholder="Enter Your Property Details" value={formData.property} onChange={handleChange} />
              {errors.property && <span className="error-text">{errors.property}</span>}
            </div>
            <div className="form3-group">
              <label>Address<span className='error fs-star'>*</span></label>
              <input type="text" name="address" placeholder="Enter Your Address" value={formData.address} onChange={handleChange} />
              {errors.address && <span className="error-text">{errors.address}</span>}
            </div>
            <div className="form3-group">
              <label>Expectation<span className='error fs-star'>*</span></label>
              <input type="text" name="expectation" placeholder="Enter your expectation" value={formData.expectation} onChange={handleChange} />
              {errors.expectation && <span className="error-text">{errors.expectation}</span>}
            </div>
          </div>

          <div className="form3-btn-group">
            <button type="button" className="back-btn-3" onClick={handleBack}>Back</button>
            <button type="button" className="submit-btn-3" onClick={HandleNext}>Continue</button>
          </div>
        </form>
      </div>
    </div>
   </> 
  ); 
};

export default Form3;
